var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPresent64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20904)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9055 10.5029C26.554 10.5029 31.7779 20.9297 31.7779 20.9297V25.6317C31.3886 25.6317 31.0109 25.6283 30.6374 25.6235C15.4941 25.4295 13.193 21.36 12.844 18.8877L12.8441 18.8863L12.8128 18.618C12.7884 18.3557 12.7831 18.116 12.782 17.9065L12.7817 17.7074C12.7817 15.6661 13.2565 10.5029 19.9055 10.5029ZM32.8403 25.6294L32.264 25.6317V20.9297C32.264 20.9297 32.2654 20.9269 32.2682 20.9214L32.3014 20.8565C32.7813 19.9294 37.8153 10.5029 44.1364 10.5029C50.7854 10.5029 51.2602 15.6661 51.2602 17.7074C51.2602 18.0214 51.263 18.4268 51.1978 18.8875C50.8495 21.36 48.5478 25.4295 33.4047 25.6237L32.8403 25.6294Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4 22.003C37.4 25.0404 34.9376 27.503 31.8995 27.503C28.8623 27.503 26.3999 25.0404 26.3999 22.003C26.3999 18.9656 28.8623 16.5029 31.8995 16.5029C34.9376 16.5029 37.4 18.9656 37.4 22.003Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9969 30.5029H52.0031C53.1059 30.5029 54 29.6089 54 28.506V24.4999C54 23.397 53.1059 22.5029 52.0031 22.5029H11.9969C10.8941 22.5029 10 23.397 10 24.4999V28.506C10 29.6089 10.8941 30.5029 11.9969 30.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9969 54.5029H50.0031C51.1059 54.5029 52 53.6089 52 52.506V30.5029H12V52.506C12 53.6089 12.8941 54.5029 13.9969 54.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 46.292L27.6966 48.5006C27.6863 48.5058 27.6735 48.502 27.6681 48.4919C27.666 48.4879 27.6652 48.4833 27.666 48.4789L28.4879 43.801L25.0064 40.4881C24.998 40.4801 24.9979 40.4671 25.006 40.459C25.0092 40.4557 25.0135 40.4536 25.018 40.453L29.8294 39.7705L31.9811 35.5144C31.9863 35.5042 31.9989 35.5 32.0093 35.5051C32.0135 35.5071 32.0168 35.5103 32.0189 35.5144L34.1706 39.7705L38.982 40.453C38.9935 40.4546 39.0015 40.4651 38.9998 40.4763C38.9991 40.4808 38.997 40.4849 38.9936 40.4881L35.5121 43.801L36.334 48.4789C36.3359 48.4901 36.3282 48.5007 36.3168 48.5026C36.3122 48.5034 36.3075 48.5027 36.3034 48.5006L32 46.292Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPresent64);
export default __webpack_public_path__ + "static/media/pictogramBeaconPresent64.8455024555931abff75cd8980d864862.svg";
export { ForwardRef as ReactComponent };